package com.swetdot.swetgram.domain

enum class PremiumAccessStatus {
    FREE,
    PENDING,
    ACTIVE,
    GRACE_PERIOD,
    ON_HOLD,
    PAUSED,
    EXPIRED,
    REVOKED,
    UNKNOWN,
}

data class PremiumAccessLimits(
    val pinnedChats: Int,
    val chatFolders: Int,
    val accounts: Int,
    val bioCharacters: Int,
    val profileLinks: Int,
    val profileGalleryPhotos: Int,
    val voiceMessageSeconds: Int,
    val fileBytes: Long,
    val storageBytes: Long,
    val scheduledMessages: Int,
    val premiumGroupStyles: Int,
    val discoverAnalyticsDays: Int,
)

data class PremiumAccess(
    val status: PremiumAccessStatus,
    val active: Boolean,
    val eligible: Boolean,
    val salesEnabled: Boolean,
    val productId: String,
    val basePlanId: String?,
    val currentPeriodEnd: String?,
    val trialEnd: String?,
    val autoRenewing: Boolean,
    val badgeVisible: Boolean,
    val limits: PremiumAccessLimits,
    val version: Int,
)
